import { type DeviceId } from '@solinkcorp/api-types';
import { type AbstractRequestor } from './shared/AbstractRequestor';
import { type VMSCamera } from './vms/vmsTypes';

export class DeviceProxyApi {
  constructor(private readonly requestor: AbstractRequestor) {}

  getCameraJson(deviceId: string, cameraId: string) {
    return this.requestor.get<{ success: boolean; camera: VMSCamera }>({
      url: `/${deviceId}/vms/cameras/${cameraId}/json`,
    });
  }

  putCameraMotion(
    deviceId: string,
    camId: string,
    motionParams: { enabled: boolean; roi: string; eventThreshold?: 1 | 2 | 3 },
  ) {
    return this.requestor.put<{ success: boolean }>({
      url: `/${deviceId}/vms/cameras/${camId}/motion`,
      data: {
        camera_id: camId,
        camera: {
          motion: motionParams,
        },
      },
    });
  }

  lightCheckin(deviceId: DeviceId) {
    return this.requestor
      .post({
        url: `${deviceId}/checkin/api/lightCheckin`,
      })
      .catch((err) => {
        // log, but don't fail if light checkin didn't succeed
        console.error('Error during light checkin', err);
      });
  }
}
